import pushClevertapEvent from 'clevertap/pushClevertapEvent';

export function clickSidebar({ menu }) {
  if (menu === 'apps') {
    pushClevertapEvent('Apps Start');
  }
}
